var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgressDone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4281 9.92836L11.4281 15.9284C11.1703 16.1862 10.8375 16.3127 10.5 16.3127C10.1625 16.3127 9.82781 16.1853 9.57141 15.9289L6.57141 12.9289C6.06 12.4161 6.06 11.5841 6.57141 11.0713C7.08422 10.5585 7.91625 10.5585 8.42906 11.0713L10.5 13.144L15.5719 8.07211C16.0847 7.5593 16.9167 7.5593 17.4295 8.07211C17.9391 8.58305 17.9391 9.41742 17.4281 9.92836Z",
    fill: "#008A45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.37187 5.37187 0 12 0C18.6281 0 24 5.37187 24 12C24 18.6281 18.6281 24 12 24C5.37187 24 0 18.6281 0 12ZM11.4281 15.9281L17.4281 9.92813C17.9391 9.41719 17.9391 8.58281 17.4295 8.07188C16.9167 7.55906 16.0847 7.55906 15.5719 8.07188L10.5 13.1438L8.42906 11.071C7.91625 10.5582 7.08422 10.5582 6.57141 11.071C6.06 11.5838 6.06 12.4159 6.57141 12.9287L9.57141 15.9287C9.82781 16.185 10.1625 16.3125 10.5 16.3125C10.8375 16.3125 11.1703 16.1859 11.4281 15.9281Z",
    fill: "#008A45"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressDone);
export default __webpack_public_path__ + "static/media/progress-done.7c4f3a9c73cce8c9b0c281ea871f0eb5.svg";
export { ForwardRef as ReactComponent };